import { motion } from "framer-motion";
import { IMAGES, STATS } from "@/data/site";
import { Reveal, Eyebrow } from "./Reveal";
import { CountUp } from "./CountUp";
import { BlueprintGrid } from "./Blueprint";
import { EASE } from "./motion";

export const Studio = () => (
  <section id="studio" className="relative bg-[#F4F3EE] py-24 lg:py-36 overflow-hidden" data-testid="studio-section">
    <BlueprintGrid className="opacity-60" />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20">
      <div className="lg:col-span-5 order-2 lg:order-1 relative">
        <motion.span
          aria-hidden="true"
          className="absolute -top-4 -left-4 right-4 bottom-4 border border-stone-400/70 pointer-events-none"
          initial={{ opacity: 0, x: 12, y: 12 }}
          whileInView={{ opacity: 1, x: 0, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1, delay: 0.4, ease: EASE }}
        />
        <Reveal variant="rise" duration={1.1} className="aspect-[3/4] overflow-hidden bg-stone-200">
          <motion.img
            src={IMAGES.portrait}
            alt="Gokul K.V., Carvings Architecture"
            className="w-full h-full object-cover object-top"
            initial={{ scale: 1.15 }}
            whileInView={{ scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1.6, ease: EASE }}
            data-testid="studio-portrait"
          />
        </Reveal>
      </div>
      <div className="lg:col-span-7 order-1 lg:order-2 lg:pt-16">
        <Reveal>
          <Eyebrow className="mb-6">01 / The Studio</Eyebrow>
          <h2 className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-stone-900">
            We design it, we build it — and we share every step with <em>you</em>.
          </h2>
        </Reveal>
        <Reveal delay={0.1} variant="draft" className="mt-10 grid sm:grid-cols-2 gap-8 text-stone-600 font-light leading-relaxed">
          <p>Carvings Architecture (Carvings Group) is an architecture and construction practice based in Thalassery, Kannur. We take homes from plan and 3D design all the way through construction.</p>
          <p>Our Instagram follows real projects on site — foundation ceremonies, laterite walls going up, renovations and handovers — so clients always know how their home is progressing.</p>
        </Reveal>
        <div className="mt-12 grid grid-cols-3 gap-6">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={0.15 + i * 0.1} variant="rise" data-testid={`studio-stat-${s.label.split(" ")[0].toLowerCase()}`}>
              <CountUp value={s.value} className="font-serif text-3xl sm:text-4xl text-stone-900" />
              <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.15em] text-stone-500">{s.label}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2} className="mt-12 pt-8 flex items-center gap-5 relative">
          <motion.span aria-hidden="true" className="absolute top-0 left-0 right-0 h-px bg-stone-300 origin-left" initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true }} transition={{ duration: 1, ease: EASE }} />
          <div>
            <p className="font-serif text-xl text-stone-900" data-testid="studio-lead-name">Gokul K.V.</p>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-stone-500">Founder, Carvings Group</p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
